import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.create');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'wiz-portal-kiosk-create',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.create/view.scss */
/* src/app/portal.kiosk.create/view.scss: no such file or directory */`],
})
export class PortalKioskCreateComponent implements OnInit {
    public countdown = 60;

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public place = '';
    public character = '';

    public async ngOnInit() {
        await this.service.init();
        this.route.queryParams.subscribe(params => {
            this.place = params['place'];
            this.character = params['character'];
            console.log(this.place)
            console.log(this.character)
        });
        await this.service.render();
    }


}

export default PortalKioskCreateComponent;